/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import DatePicker from 'react-datepicker';
import { setLoader, setSelectedPeriod, setSelectedCustomPeriod } from '../../redux/reducer';
import i18next from '../../translations/i18n';
import utils from '../../services/Utils';

import 'react-datepicker/dist/react-datepicker.css';

const DATE_FORMAT_DD_MM_YYYY = 'dd/MM/yyyy';
const formatYMD = d =>
  d
    ? `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
    : null;

const CalendarArrow = ({ direction, double }) => {
  const iconClass = `react-datepicker__navigation-icon react-datepicker__navigation-icon--${direction === 'left' ? 'previous' : 'next'}`;

  return (
    <span className="chart-calendar-arrow" aria-hidden="true">
      <span className={iconClass} />
      {double && <span className={iconClass} />}
    </span>
  );
};

const CalendarHeader = ({
  date,
  decreaseMonth,
  increaseMonth,
  decreaseYear,
  increaseYear,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled,
  prevYearButtonDisabled,
  nextYearButtonDisabled,
}) => {
  const months = i18next.t('months', { returnObjects: true });
  const month = months[date.getMonth()];

  return (
    <div className="chart-calendar-navigation">
      <div className="chart-calendar-navigation__arrows">
        <button
          type="button"
          aria-label="Previous year"
          disabled={prevYearButtonDisabled}
          onClick={decreaseYear}
        >
          <CalendarArrow direction="left" double />
        </button>
        <button
          type="button"
          aria-label="Previous month"
          disabled={prevMonthButtonDisabled}
          onClick={decreaseMonth}
        >
          <CalendarArrow direction="left" />
        </button>
      </div>
      <span className="chart-calendar-navigation__month">
        {month} {date.getFullYear()}
      </span>
      <div className="chart-calendar-navigation__arrows">
        <button
          type="button"
          aria-label="Next month"
          disabled={nextMonthButtonDisabled}
          onClick={increaseMonth}
        >
          <CalendarArrow direction="right" />
        </button>
        <button
          type="button"
          aria-label="Next year"
          disabled={nextYearButtonDisabled}
          onClick={increaseYear}
        >
          <CalendarArrow direction="right" double />
        </button>
      </div>
    </div>
  );
};

const PeriodSelector = () => {
  const dispatch = useDispatch();

  const {
    timePeriods,
    selectedPeriod = '',
    firstStartDate,
    lastEndDate,
    selectedPeriodFilteredData,
  } = useSelector(state => state.app);

  const [calenderStartDate, setStartDate] = useState(new Date());
  const [calenderEndDate, setEndDate] = useState(new Date());

  useEffect(() => {
    dispatch(setLoader(false));
    const [firstDate, latestDate] = utils.getFirstAndLastDates(selectedPeriodFilteredData);
    setStartDate(firstDate);
    setEndDate(latestDate);
  }, [selectedPeriod, selectedPeriodFilteredData]);

  return (
    <div className="period-selector">
      <ul className="nav nav-tabs period-tabs">
        {timePeriods
          .filter(label => label !== 'CUSTOM')
          .map(label => (
            <li
              key={label}
              className={`tab-responsive ${selectedPeriod === label ? 'active' : ''}`}
            >
              <button
                type="button"
                className="nav-link"
                onClick={() => dispatch(setSelectedPeriod(label))}
              >
                {i18next.t(label)}
              </button>
            </li>
          ))}
      </ul>
      <div className="wt-charts-date">
        <div className="wt-charts-input">
          <label htmlFor="chart-from-date" className="date-label">
            {i18next.t('FROM')}
          </label>
          <DatePicker
            id="chart-from-date"
            selected={calenderStartDate}
            onChange={date => {
              setStartDate(date);
              const range = [formatYMD(date), formatYMD(calenderEndDate)];
              if (date) {
                dispatch(setSelectedCustomPeriod({ period: 'CUSTOM', range }));
              }
            }}
            className="date-picker"
            minDate={firstStartDate}
            maxDate={lastEndDate}
            calendarClassName="chart-calendar"
            renderCustomHeader={CalendarHeader}
            fixedHeight
            wrapperClassName="datePicker"
            dateFormat={DATE_FORMAT_DD_MM_YYYY}
            placeholderText={i18next.t('FROM')}
            enableTabLoop={false}
          />
        </div>
        <div className="wt-charts-input">
          <label htmlFor="chart-to-date" className="date-label">
            {i18next.t('TO')}
          </label>
          <DatePicker
            id="chart-to-date"
            selected={calenderEndDate}
            onChange={date => {
              setEndDate(date);
              const range = [formatYMD(calenderStartDate), formatYMD(date)];
              if (date) {
                dispatch(setSelectedCustomPeriod({ period: 'CUSTOM', range }));
              }
            }}
            className="date-picker"
            minDate={calenderStartDate}
            maxDate={lastEndDate}
            calendarClassName="chart-calendar"
            renderCustomHeader={CalendarHeader}
            fixedHeight
            wrapperClassName="datePicker"
            dateFormat={DATE_FORMAT_DD_MM_YYYY}
            placeholderText={i18next.t('TO')}
            enableTabLoop={false}
          />
        </div>
      </div>
    </div>
  );
};

export default PeriodSelector;
